export const size = {
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptop: 1024,
  laptopL: 1440,
  laptopM: 1280,
  desktop: 2560,
};

export const device = {
  mobileS: `(max-width: ${size.mobileM}px)`,
  mobileM: `(max-width: ${size.mobileL}px)`,
  mobileL: `(max-width: ${size.tablet}px)`,
  tablet: `(max-width: ${size.laptop}px)`,
  laptopM: `(max-width: ${size.laptopM}px)`,
  laptop: `(max-width: ${size.laptopL}px)`,
  laptopL: `(max-width: ${size.desktop}px)`,
};
